import type { CrmTranslate } from './crm-copy';

export function createCrmGettingStartedCopy(t: CrmTranslate) {
  return {
    gettingStarted: {
      setupQuestion: {
        title: t('crm.gettingStarted.setupQuestion.title'),
        subtitle: t('crm.gettingStarted.setupQuestion.subtitle'),
        submitLabel: t('crm.gettingStarted.setupQuestion.submitLabel'),
        industries: {
          b2b_saas: {
            label: t('crm.gettingStarted.setupQuestion.industries.b2b_saas.label'),
            description: t('crm.gettingStarted.setupQuestion.industries.b2b_saas.description'),
          },
          real_estate: {
            label: t('crm.gettingStarted.setupQuestion.industries.real_estate.label'),
            description: t('crm.gettingStarted.setupQuestion.industries.real_estate.description'),
          },
          other: {
            label: t('crm.gettingStarted.setupQuestion.industries.other.label'),
            description: t('crm.gettingStarted.setupQuestion.industries.other.description'),
          },
        },
      },
      sampleDataQuestion: {
        title: t('crm.gettingStarted.sampleDataQuestion.title'),
        subtitle: t('crm.gettingStarted.sampleDataQuestion.subtitle'),
        yes: t('crm.gettingStarted.sampleDataQuestion.yes'),
        no: t('crm.gettingStarted.sampleDataQuestion.no'),
      },
      steps: {
        addContact: {
          title: t('crm.gettingStarted.steps.addContact.title'),
          description: t('crm.gettingStarted.steps.addContact.description'),
          actionLabel: t('crm.gettingStarted.steps.addContact.actionLabel'),
        },
        addCompany: {
          title: t('crm.gettingStarted.steps.addCompany.title'),
          description: t('crm.gettingStarted.steps.addCompany.description'),
          actionLabel: t('crm.gettingStarted.steps.addCompany.actionLabel'),
        },
        createDeal: {
          title: t('crm.gettingStarted.steps.createDeal.title'),
          description: t('crm.gettingStarted.steps.createDeal.description'),
          actionLabel: t('crm.gettingStarted.steps.createDeal.actionLabel'),
        },
        importContacts: {
          title: t('crm.gettingStarted.steps.importContacts.title'),
          description: t('crm.gettingStarted.steps.importContacts.description'),
          actionLabel: t('crm.gettingStarted.steps.importContacts.actionLabel'),
        },
        configurePipeline: {
          title: t('crm.gettingStarted.steps.configurePipeline.title'),
          description: t('crm.gettingStarted.steps.configurePipeline.description'),
          actionLabel: t('crm.gettingStarted.steps.configurePipeline.actionLabel'),
        },
        inviteTeam: {
          title: t('crm.gettingStarted.steps.inviteTeam.title'),
          description: t('crm.gettingStarted.steps.inviteTeam.description'),
          actionLabel: t('crm.gettingStarted.steps.inviteTeam.actionLabel'),
        },
      },
      guide: {
        eyebrow: t('crm.gettingStarted.guide.eyebrow'),
        title: t('crm.gettingStarted.guide.title'),
        subtitle: t('crm.gettingStarted.guide.subtitle'),
        completeLabel: t('crm.gettingStarted.guide.completeLabel'),
        dismissLabel: t('crm.gettingStarted.guide.dismissLabel'),
        completedContent: t('crm.gettingStarted.guide.completedContent'),
        completeActionLabel: t('crm.gettingStarted.guide.completeActionLabel'),
      },
    },
  };
}
